import script from "./AdminDiscountsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDiscountsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminDiscountsPage.vue?vue&type=style&index=0&id=711217a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711217a4"]])

export default __exports__